import { render, staticRenderFns } from "./FlexColumnDragItem.vue?vue&type=template&id=1b568daa"
import script from "./FlexColumnDragItem.vue?vue&type=script&lang=js"
export * from "./FlexColumnDragItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports